import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BenefitProvider } from '../../module/benefits/BenefitContext';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import { AdditionalEmployeeColumns } from '../../module/benefits/employeeStatusList/EmployeeBenefitStatusList';

import { useOrderedBenefits } from '../../module/benefits/useOrderedBenefits';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';
import { EmployeesPage } from './EmployeesPage';

export const BenefitEmployeesPage: React.FC<{ benefit: BenefitDTOBenefitEnum; additionalColumns?: AdditionalEmployeeColumns }> = ({
  benefit,
  additionalColumns,
}) => {
  const { t } = useTranslation('benefitsModule');
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const { activeBenefits } = useOrderedBenefits(tenant);

  useEffect(() => {
    if (!activeBenefits.includes(benefit)) {
      // benefit is not active, should not be here
      navigate('/');
    }
  }, [activeBenefits, benefit, navigate]);

  return (
    <AuthorizedLayout
      title={t('subPage.employees')}
      breadcrumbs={[{ title: t(`${benefit}.title`), to: `/benefits/${benefit.toLowerCase()}` }]}
    >
      <BenefitProvider benefit={benefit}>
        <EmployeesPage
          benefit={benefit}
          additionalColumns={additionalColumns}
          icon={getBenefitIcon(benefit)}
          title={t(`${benefit}.title`)}
          subTitle={t('subPage.employees')}
        />
      </BenefitProvider>
    </AuthorizedLayout>
  );
};
